module.exports = __webpack_public_path__ + "img/Group_1000001910.873c7cc6.png";